// Spoken upload updates via the browser's built-in speech synthesis.
export const VOICE_KEY = "f2_voice_updates";

export const voiceEnabled = () => localStorage.getItem(VOICE_KEY) !== "0";

export const setVoiceEnabled = (on) => localStorage.setItem(VOICE_KEY, on ? "1" : "0");

let _last = { text: "", at: 0 };

export function speak(text) {
  if (!text || !voiceEnabled()) return;
  if (typeof window === "undefined" || !window.speechSynthesis) return;
  // Skip an identical phrase repeated within 2s (double renders / rapid tab flips).
  const now = Date.now();
  if (_last.text === text && now - _last.at < 2000) return;
  _last = { text, at: now };
  try {
    const u = new SpeechSynthesisUtterance(text);
    u.rate = 1;
    window.speechSynthesis.speak(u);
  } catch {
    // Speech unsupported — silently skip.
  }
}

const plural = (n, word) => `${n} ${word}${n === 1 ? "" : "s"}`;

// "3 photos uploaded. 2 photos waiting, will retry. 1 photo failed."
export function announceBatch({ uploaded = 0, queued = 0, failed = 0 }) {
  const parts = [];
  if (uploaded) parts.push(`${plural(uploaded, "photo")} uploaded`);
  if (queued) parts.push(`${plural(queued, "photo")} waiting, will retry`);
  if (failed) parts.push(`${plural(failed, "photo")} failed`);
  speak(parts.join(". "));
}
